import Button from "components/Button/index";
import Lottie from "lottie-react";

import useScreenMobile from "hooks/useScreen";
import successAnime from "assets/json/success.json";
import failureAnime from "assets/json/failure.json";

import "./signupSuccess.scss";
const SignupSuccess = ({
    title = "",
    titleWidth = "",
    titleMobileWidth = "",
    subTitle = "",
    subTitleWidth = "",
    subTitleMobileWidth = "",
    buttonText = "",
    buttonPlus = "",
    image,
    altText = "",
    imgWidth = "",
    imgHeight = "",
    imgMaxheight = "",
    imgMaxwidth = "",
    onClick,
    setStep,
    password,
    success,
    setOrgUserSuccess,
    background = false,
    btn = true
}) => {
    const isMobile = useScreenMobile({ size: 568 });
    const lottieImage = success ? successAnime : failureAnime;

    const handleBYOS = () => {
        setStep("-1");
        setOrgUserSuccess("");
    };
    return (
        <>
            <section
                className="account"
                style={{
                    backgroundImage: background && "none",
                    backgroundColor: background && "transparent",
                    padding: background && "0"
                }}
            >
                <div className="container accountContainer">
                    <div className="accountBox">
                        {!image && (
                            <Lottie
                                animationData={lottieImage}
                                loop={true}
                                style={{ height: 120, width: 120 }}
                                className="lottie"
                            />
                        )}
                        {image && (
                            <div
                                className="imageWrapper"
                                style={{
                                    maxWidth: imgMaxwidth,
                                    maxHeight: imgMaxheight,
                                    height: imgHeight,
                                    width: imgWidth
                                }}
                            >
                                <img src={image} alt={altText} />
                            </div>
                        )}
                        <div className="commonHeading">
                            <h1
                                style={{ maxWidth: isMobile ? titleMobileWidth : titleWidth }}
                            >
                                {title}
                            </h1>
                            <p
                                style={{
                                    maxWidth: isMobile ? subTitleMobileWidth : subTitleWidth
                                }}
                            >
                                {subTitle}
                            </p>
                        </div>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "12px" }}>
                            <Button
                                type="violet"
                                title={buttonText}
                                showImage={buttonPlus}
                                onClick={() => {
                                    onClick();
                                }}
                            />
                            <Button
                                type="violet"
                                title={"Bring your own storage"}
                                showImage={buttonPlus}
                                onClick={() => {
                                    handleBYOS();
                                }}
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default SignupSuccess;
